// extracted by mini-css-extract-plugin
export default {"button":"UpgradeTariffButton_button__JMCXn"};